import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import ColorRange from '../ColorRange';

import { SYMBOLOGY_TYPES } from '../../../api/Styles/Styles';

const CATEGORIZED_COLOR_RANGES = ['Set1', 'Set3', 'Paired', 'Dark2', 'Accent', 'Pastel1'];

const NUMERIC_COLOR_RANGES = ['Reds', 'Greys', 'PuBu', 'RdYlGn', 'Oranges', 'RdYlBu'];

const CUSTOM = 'custom';

const ColorRangesField = ({ changeColorScale, colorRange, symbologyType, isCustom, hasCustom }) => {
  let colorRangeToUse = [];
  if (symbologyType === SYMBOLOGY_TYPES.NUMERIC) {
    colorRangeToUse = NUMERIC_COLOR_RANGES;
  } else if (symbologyType === SYMBOLOGY_TYPES.CATEGORIZED) {
    colorRangeToUse = CATEGORIZED_COLOR_RANGES;
  }
  return (
    <Form.Group>
      {hasCustom && <Form.Label>Color Range</Form.Label>}
      {colorRangeToUse.map(COLOR_RANGE => (
        <Form.Check key={COLOR_RANGE}>
          <Form.Check.Input
            type="radio"
            name="colorRangeValues"
            value={COLOR_RANGE}
            defaultChecked={COLOR_RANGE === colorRange}
            onClick={changeColorScale}
            isValid
          />
          <Form.Check.Label className="w-100">
            <ColorRange stepped colorRange={COLOR_RANGE} />
          </Form.Check.Label>
        </Form.Check>
      ))}
      {hasCustom && (
        <Form.Check>
          <Form.Check.Input
            type="radio"
            name="colorRangeValues"
            value={CUSTOM}
            checked={isCustom}
            onClick={changeColorScale}
          />
          <Form.Check.Label className="w-100">Custom</Form.Check.Label>
        </Form.Check>
      )}
    </Form.Group>
  );
};
ColorRangesField.defaultProps = {
  hasCustom: true
};
ColorRangesField.propTypes = {
  hasCustom: PropTypes.bool,
  changeColorScale: PropTypes.func.isRequired,
  colorRange: PropTypes.string.isRequired,
  symbologyType: PropTypes.string.isRequired,
  isCustom: PropTypes.bool.isRequired
};

export default ColorRangesField;
